import { LayoutType } from '../types/asset-types';

export const DEFAULT_LAYOUT_OPTION: { value: LayoutType; label: string; icon: string } = {
  value: 'DEFAULT',
  label: 'Original',
  icon: 'IconVideo'
};

export const SCENE_LAYOUT_TYPES: { value: LayoutType; label: string; icon: string }[] = [
  { value: 'SPEAKER', label: 'Fullscreen', icon: 'IconUserScan' },
  { value: 'GRID', label: 'Grid', icon: 'IconLayoutGrid' },
  { value: 'FOCUS', label: 'Focus', icon: 'IconLayoutSidebarRight' },
  { value: 'PIP', label: 'Picture in Picture', icon: 'IconPictureInPicture' }
];

export const CLIP_CUSTOMIZER_LAYOUT_TYPES = [
  ...SCENE_LAYOUT_TYPES,
  { value: 'AUDIOGRAM', label: 'Audiogram', icon: 'IconPhotoVideo' },
  DEFAULT_LAYOUT_OPTION
];
